export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/wmd-logo-promotion-spanish-b9b4a29eddcc1228e7e6878b8401fec0.svg";